import { defineComponent as _defineComponent } from 'vue'
import { computed } from "@nuxtjs/composition-api";
import DOMPurify from "isomorphic-dompurify";

import { useTranslate } from "@/composables";


export default /*#__PURE__*/_defineComponent({
  __name: 'RetailerProductDetailsModal',
  props: {
  body: {
    type: String,
    required: true,
  },
},
  emits: ["open-modal-click"],
  setup(__props, { emit }: { emit: ({
  (e: "open-modal-click"): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props;

const { t } = useTranslate();



function onClick() {
  emit("open-modal-click");
}

const sanitizedBody = computed(() => DOMPurify.sanitize(props.body));
const titleText = t("Product Details" /* Product details for retailer products */);

return { __sfc: true,t, props, emit, onClick, sanitizedBody, titleText }
}

})